import {TypologyLabel} from "@modules/activities/core/typologies/typology.label";

export const EDITOR_TYPOLOGY_LABEL = {
    ...TypologyLabel,
    shortAnswerButLong: 'shortAnswerButLong',
    twoMedia: 'twoMedia',
} as const;

export type EDITOR_TYPOLOGY_LABEL = typeof EDITOR_TYPOLOGY_LABEL[keyof typeof EDITOR_TYPOLOGY_LABEL];

export const toTypologyLabel = (label: EDITOR_TYPOLOGY_LABEL) => {
    const newLabelToOldLabelMapping = {
        [EDITOR_TYPOLOGY_LABEL.shortAnswerButLong]: TypologyLabel.shortAnswer,
    }

    if (newLabelToOldLabelMapping[label]) {
        return newLabelToOldLabelMapping[label];
    }

    return label as TypologyLabel;
}